import type {
  SensorTopology,
  SensorTopologyChanges,
  ScrapEyeSensorConnectionRead,
  ScrapEyeSensorPlacementRead,
} from "src/store/api/generatedApi";

export interface TopologySelection {
  kind: "sensor" | "device" | "position";
  id: number;
}
export type TopologyEdit =
  | { kind: "connect"; sensorId: number; deviceId: number | null }
  | {
      kind: "reconnect";
      connection: ScrapEyeSensorConnectionRead;
      deviceId: number | null;
    }
  | {
      kind: "move";
      installation: ScrapEyeSensorPlacementRead;
      positionId: number | null;
    }
  | { kind: "install"; sensorId: number; positionId: number | null }
  | {
      kind: "end";
      connections: ScrapEyeSensorConnectionRead[];
      installations: ScrapEyeSensorPlacementRead[];
    }
  | { kind: "sensor" }
  | { kind: "device" };

export const endConnection = (
  connection: ScrapEyeSensorConnectionRead,
  at: string
) => ({
  expected_version_id: connection.id,
  connection: {
    sensor_id: connection.sensor_id,
    device_id: connection.device_id,
    device_sensor_id: connection.device_sensor_id,
    camera_id: connection.camera_id,
    connected_at: connection.connected_at,
    disconnected_at: at,
  },
});

export const endInstallation = (
  installation: ScrapEyeSensorPlacementRead,
  at: string
) => ({
  expected_version_id: installation.id,
  installation: {
    sensor_id: installation.sensor_id,
    recording_position_id: installation.recording_position_id,
    priority: installation.priority,
    installed_at: installation.installed_at,
    removed_at: at,
  },
});

export const activeConnections = (topology: SensorTopology) =>
  topology.connections.filter((connection) =>
    topology.active_connection_ids.includes(connection.id)
  );
export const activeInstallations = (topology: SensorTopology) =>
  topology.installations.filter((installation) =>
    topology.active_installation_ids.includes(installation.id)
  );

export const endRelationships = (
  edit: Extract<TopologyEdit, { kind: "end" }>,
  at: string
): SensorTopologyChanges => ({
  connections: edit.connections.map((connection) =>
    endConnection(connection, at)
  ),
  installations: edit.installations.map((installation) =>
    endInstallation(installation, at)
  ),
});
